var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewCalendar = function SvgNewCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22252E",
    d: "M23.467 7.273h-.934v-1.94h-1.866v1.94h-9.334v-1.94H9.467v1.94h-.934c-1.026 0-1.866.872-1.866 1.94v15.514c0 1.067.84 1.94 1.866 1.94h14.934c1.026 0 1.866-.873 1.866-1.94V9.212c0-1.067-.84-1.94-1.866-1.94m0 17.454H8.533V14.061h14.934zm0-12.606H8.533V9.212h14.934z"
  })));
};
export { SvgNewCalendar as ReactComponent };